<template>
  <div class="about-page">
    <div class="page-header">
      <h2 class="page-title">{{ aboutInfo.title || '关于我们' }}</h2>
    </div>
    <div class="container">
      <div class="content" v-html="aboutInfo.content"></div>
    </div>
    <PageFooter />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { getAboutInfo } from '@/api/video'
import PageFooter from './Footer.vue'

export default {
  name: 'AboutPage',
  components: {
    PageFooter
  },
  setup() {
    const aboutInfo = ref({
      title: '',
      content: ''
    })

    const fetchAboutInfo = async () => {
      try {
        const res = await getAboutInfo()
        if (res.code === 1) {
          aboutInfo.value = res.data
        }
      } catch (error) {
        console.error('获取关于我们信息失败:', error)
      }
    }

    onMounted(() => {
      fetchAboutInfo()
    })

    return {
      aboutInfo
    }
  }
}
</script>

<style scoped>
.about-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #f6f7f9 0%, #f0f2f5 100%);
  padding: 40px 0;
}

.page-header {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 24px;
}

.page-title {
  font-size: 24px;
  color: #1a1a2e;
  font-weight: 700;
  margin: 0;
  position: relative;
  padding-left: 16px;
}
.page-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 24px;
  background: linear-gradient(180deg, #ff6a00, #ff9600);
  border-radius: 2px;
}

.container {
  flex: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0,0,0,0.02);
  width: 100%;
  box-sizing: border-box;
}

.content {
  color: #333;
  line-height: 1.8;
  font-size: 16px;
}

.content :deep(p) {
  margin-bottom: 16px;
  color: #475569;
}

.content :deep(h1),
.content :deep(h2),
.content :deep(h3),
.content :deep(h4) {
  color: #1a1a2e;
  margin-top: 28px;
  margin-bottom: 14px;
  font-weight: 600;
}

.content :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  margin: 20px 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.content :deep(a) {
  color: #ff9600;
  text-decoration: none;
  font-weight: 500;
}
.content :deep(a:hover) {
  text-decoration: underline;
}

.content :deep(ul),
.content :deep(ol) {
  padding-left: 24px;
  margin-bottom: 16px;
}

.content :deep(li) {
  margin-bottom: 6px;
  color: #475569;
}

.content :deep(blockquote) {
  margin: 16px 0;
  padding: 12px 20px;
  border-left: 4px solid #ff9600;
  background: #fff7ed;
  border-radius: 0 8px 8px 0;
  color: #666;
}
</style>